import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-background-50 px-4 text-center">
      <div className="absolute -top-20 right-0 h-64 w-64 rounded-full bg-primary-100/60"></div>
      <div className="absolute -bottom-24 left-0 h-72 w-72 rounded-full bg-accent-100/60"></div>
      <p className="relative font-heading text-[7rem] font-black leading-none text-primary-500 md:text-[10rem]">404</p>
      <h1 className="relative mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">这块瓜地还没开垦</h1>
      <p className="relative mt-3 max-w-md text-foreground-600">你访问的页面不存在或已被移除，去今日首页和资讯速递看看新鲜内容吧。</p>
      <div className="relative mt-8 flex flex-col items-center gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" aria-hidden="true"></i>返回首页
        </Link>
        <Link
          to="/news"
          className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-6 py-3 text-sm font-semibold whitespace-nowrap text-foreground-800 transition-colors hover:bg-secondary-100"
        >
          <i className="ri-article-line" aria-hidden="true"></i>浏览资讯速递
        </Link>
      </div>
    </div>
  );
}